// 验证基类
class RuleClass {
  constructor(options) {
    this.maxLength = options.maxLength
    this.minLength = options.minLength
    this.errorTip = options.errorTip
    this.type = options.type
  }

  config(options) {
    if (options.errorTip) {
      this.errorTip = options.errorTip
    }
  }

  filter() {
    throw new Error('filter value method should implement child class')
  }

  validateFunc() {
    throw new Error('filter value method should implement child class')
  }
}

// 数字限制验证
class NumberRule extends RuleClass {
  // 自定义配置方法
  config(options) {
    super.config(options)
    this.maxLength = options.maxLength
    this.minLength = options.minLength
  }

  // 过滤规则
  filter(val) {
    return val.replace(/\D/g, '').replace(/^[0]+[0-9]*$/g, '')
  }

  // 验证(覆盖父类验证方法)
  validateFunc(val) {
    return val.length <= this.maxLength && val.length >= this.minLength
  }
}

class PhoneRule extends RuleClass {
  // 自定义配置方法
  config(options) {
    super.config(options)
    this.maxLength = options.maxLength
    this.minLength = options.minLength
  }

  // 过滤规则
  filter(val) {
    return val.replace(/\D/g, '').replace(/^[0]+[0-9]*$/g, '')
  }

  // 手机号码验证(覆盖父类验证方法)
  validateFunc(val) {
    return val.length === this.maxLength && /^1[3456789]\d{9}$/.test(val)
  }
}

// 字符验证
class CharRule extends RuleClass {
  // 自定义配置方法
  config(options) {
    super.config(options)
    this.maxLength = options.maxLength
    this.minLength = options.minLength
  }

  // 过滤特殊字符
  filter(val) {
    return val
  }

  validateFunc(val) {
    return val.length >= this.minLength && val.length <= this.maxLength
  }
}

const phoneNum = new PhoneRule({
  maxLength: 11,
  errorTip: '',
  type: 'tel'
})

const qq = new NumberRule({
  minLength: 5,
  maxLength: 11,
  errorTip: '',
  type: 'tel'
})

const char = new CharRule({
  minLength: 2,
  maxLength: 32,
  errorTip: '',
  type: 'text'
})

export const validator = {
  // 手机号码
  phoneNum,
  // qq 号码
  qq,
  // 无限制
  char
}
